import React, { Component } from "react";
import AttributeTypes from "./AttributeTypes";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import DateTimeTypeField from "./Fields/DateTimeTypeField";
import NumberTypeField from "./Fields/NumberTypeField";
import DummyLabelHelper from "./DummyLabel"
import { PicklistOptionsField } from "./Fields/PicklistStringFields";
import { StateFeildOptionsField } from "./Fields/StateFields";
import InnerLoader from "../Shared/Loader/InnerLoader";
import ErrorMessage from "../Shared/Error/ErrorMessage";
import AttributeTypePopup from "./AttributeTypePopup";
import { OverlayLoader } from "../Shared/Loader/OverlayLoader";
import { createAttribute } from "../../API/Attribute/Attribute";
import TreeDropdown from "./Fields/TreeDropdown";
import { CheckErrorInTree, removeExtraSpaceFromTreeElement, uuidv4 } from "./Fields/TreeDropdownHelper";
import { removeSpecialCharacters } from "../Entities/utils";
import { withTranslation } from "react-i18next";
import MirrorField from "./Fields/MirrorField";
import { createRelationshipV1 } from "../Helpers/Relationships";

class CreateAttributeDialog extends Component {

	DataTypes = AttributeTypes.Types;
	Icons = AttributeTypes.Icons;
	BaseFields = AttributeTypes.BaseFields;
	Fields = AttributeTypes.Fields;

	attributeTypeRender = (li, itemProps) => {
		const itemChildren = (
			<div className="items-center w-100 d-flex">
				<div style={{ width: "20px" }}>
					<i className={itemProps.dataItem.icon}></i>
				</div>
				{itemProps.dataItem.text}
			</div>
		);
		return React.cloneElement(li, { tabIndex: 0 }, itemChildren);
	};

	constructor(props) {
		super(props);
		this.DataTypes = AttributeTypes.getTranslatedTypes(props.t);
		this.state = {
			data: [],
			allAttributes: [],
			attributeName: "",
			nameError: "",
			validName: true,
			DataTypes: this.DataTypes,
			attributeType: this.DataTypes[0],
			picklistError: {
				isValid: true,
				message: "",
			},
			statefieldError: {
				isValid: true,
				message: "",
			},
			treedropdownError: {
				isValid: true,
				message: "",
			},
			treeDropdown: [{
				id: uuidv4(),
				text: "",
				parentId: null,
				items: [],
				root: true,
				expandedLevel: 1,
			}],
			dateTimeType: "date",
			numberType: "integer",
			creatingAttribute: false,
			showAttributeTypePopup: false,
		};
		this.createBtn = React.createRef();
		this.createAndNewBtn = React.createRef();
	}

	componentDidMount = async () => {
		this.setState({
			data: [...this.props.data],
			allAttributes: [...this.props.allAttributes],
		});
	};

	render() {
		const { t } = this.props;
		const hasStateField = this.state.data.some(attribute =>
			attribute.attributeType === "State Field" ||
			(attribute.attributeType === "Mirror" && attribute.attribute.attributeType === "State Field")
		);
		return (
			<>
				<Dialog title={t('title')} onClose={this.closeAttributeDialog} height={470}>
					<fieldset className="h-100" disabled={this.state.creatingAttribute}>
						<form onSubmit={this.createAttributeandResetForm} className="d-flex flex-column h-100" >
							<div>
								<div className="me-1 form-label d-inline-block" required>
									{t("name_field_label")}
								</div>
								<ErrorMessage
									valid={this.state.validName}
									error={this.state.nameError}
								/>
								<input maxLength={64} onChange={this.handleName} className="form-control name-text" autoFocus={true} type="text" ref={(rf) => (this.attributeNameInput = rf)} value={this.state.attributeName} />
							</div>
							<div>
								<div className="d-flex justify-content-between">
									<div className="form-label">
										{t("type_field_label")}
									</div>
									<a
										className="form-label text-link fw-bold cursor-pointer"
										onClick={this.toggleAttributeTypesPopup}>
										{t("tell_me_more_text")}
									</a>
								</div>
								<ComboBox
									className="form-control-custom"
									data={this.getDataTypes()}
									textField="text"
									itemRender={this.attributeTypeRender}
									onFilterChange={this.handleType}
									filterable={true}
									onChange={this.setAttributeType}
									suggest={true}
									allowCustom={false}
									value={this.state.attributeType}
								/>
							</div>
							<div className="flex-grow-1">
								{this.state.attributeType.value === "DateTime" && <div className="mt-4"><DateTimeTypeField value={this.state.dateTimeType} onChange={this.handleDateTimeType} /></div>}
								{this.state.attributeType.value === "Number" && <div className="mt-4"><NumberTypeField value={this.state.numberType} onChange={this.handleNumberType} /></div>}
								{this.state.attributeType.value === "Picklist String" && (
									// <Scrollable noPadding={true} ref={this.scrollRef}>
									<div className="mt-2">
										<div className="form-label">
											<span required>{t("dropdown_values_label")}</span>
											{this.state.picklistError.isValid === false && <span className="mx-1 text-danger">{this.state.picklistError.message}</span>}
										</div>
										<div className="drop-container">
											<PicklistOptionsField
												onChange={this.handleDropdownChange} value={this.state.picklist}
												onErr={(e) => {
													let { picklistError } = this.state;
													picklistError.isValid = e.length < 0;
													this.setState({
														picklistError: picklistError,
													});
												}}
												autoFocus={true}
											/>
										</div>

									</div>
									// </Scrollable>
								)}
								{this.state.attributeType.value === "State Field" && (
									// <Scrollable noPadding={true} ref={this.scrollRef}>
									<div className="mt-2">
										<div className="form-label">
											<span required>{t("state_field_label")}</span>
											{this.state.statefieldError.isValid === false && <span className="mx-1 text-danger">{this.state.statefieldError.message}</span>}
										</div>
										<div className="drop-container">
											<StateFeildOptionsField
												showLanguageTranslation={false}
												onChange={this.handleStateFieldChange}
												value={this.state.statefield}
												onErr={(e) => {
													let { statefieldError } = this.state;
													statefieldError.isValid = e.length < 0;
													this.setState({
														statefieldError: statefieldError,
													});
												}}
												autoFocus={true}
												showColorPicker={false}
												TooltipPosition={'left'}
											/>
										</div>

									</div>
									// </Scrollable>
								)}
								{this.state.attributeType.value === "Tree Dropdown" && (
									<div className="mt-3">
										<div className="form-label d-inline-block" required>
											{t("tree_dropdown_label")}
										</div>
										<ErrorMessage visible={this.state.treedropdownError.isValid} error={this.state.treedropdownError.message} />
										<div className="drop-container-treedropdown">
											<TreeDropdown
												isNew={true}
												onUpdate={this.handleTreeDropdownChange}
												defaultTreeDropdown={this.state.treeDropdown}
											/>
										</div>
									</div>
								)}
								{
									this.state.attributeType.value === "Mirror" && (
										<div className="mt-3">
											<div className="d-inline-block">
												{t("mirror_label")}
											</div>
											<MirrorField
												attributes={this.state.data}
												entityId={this.props.entityId}
												entity={this.state.entity}
												relation={this.state.relation}
												attribute={this.state.attribute}
												onEntityChange={this.handleMirrorFieldChange}
												onRelationChange={this.handleMirrorFieldChange}
												onAttributeChange={this.handleMirrorFieldChange}
											/>
										</div>
									)
								}
							</div>
							<DialogActionsBar layout="end">
								<small className="mt-1">
									{this.state.creatingAttribute && (
										<div className="d-inline-block">
											<InnerLoader borderColor="green" />
											<span className="me-4 text-success"></span>
										</div>
									)}
								</small>
								<button className="btn btn-secondary" onClick={this.closeAttributeDialog} type="button">
									{t("buttons.cancel_label")}
								</button>
								<button ref={this.createAndNewBtn} name="CreateNew" className="btn btn-primary" disabled={this.shouldCreateBeDisabled()} type={(this.state.attributeType.value === "Picklist String" || this.state.attributeType.value === "State Field") ? "button" : "submit"}
									onClick={this.createAttributeandResetForm}>
									{t("buttons.create_and_new_label")}
								</button>
								<button ref={this.createBtn} name="Create" className="btn btn-primary" disabled={this.shouldCreateBeDisabled()} onClick={this.createAttribute} type="button">
									{t("buttons.create_label")}
								</button>
							</DialogActionsBar>
						</form>
					</fieldset >
					{this.state.creatingAttribute &&
						<OverlayLoader />
					}
				</Dialog>
				{
					this.state.showAttributeTypePopup &&
					<AttributeTypePopup
						excludedTypes={hasStateField ? ["Shared Lookup", "State Field"] : ["Shared Lookup"]}
						data={this.state.data}
						advancedMode={this.props.advancedMode}
						onClose={this.toggleAttributeTypesPopup}
						onSelect={this.selectAttributeTypeAndClosePopup} />
				}
			</>
		);
	}

	getDataTypes = () => {
		const isStateAttributeExist = this.state.data.findIndex((attribute) =>
			attribute.attributeType === "State Field" ||
			(attribute.attributeType === "Mirror" && attribute.attribute.attributeType === "State Field")
		) > -1
		if (isStateAttributeExist) {
			return this.state.DataTypes.filter((item) => item.value !== "State Field" && item.value !== "Shared Lookup");
		}
		return this.state.DataTypes.filter((item) => item.value !== "Shared Lookup");
	}

	closeAttributeDialog = () => {
		this.props.closeDialog(false);
	};

	toggleAttributeTypesPopup = () => {
		this.setState({ showAttributeTypePopup: !this.state.showAttributeTypePopup });
	}

	selectAttributeTypeAndClosePopup = (value) => {
		this.setAttributeType({ target: { value } });
		this.toggleAttributeTypesPopup();
	}

	handleName = (e) => {
		const nameIsReserved = e.target.value.toLowerCase().replace(/[^a-zA-Z0-9]/g, "").trim() === "id"
		const nameIsBlank = e.target.value.trim() === ""
		const nameInUse = this.state.data.findIndex((attribute) => (
			removeSpecialCharacters(attribute.attributeName.toLowerCase()) === removeSpecialCharacters(e.target.value.trim().toLowerCase())
		)) > -1;
		const nameContainsSys = /^\[SYS\]/i.test(e.target.value);
		const nameStartWithNumber = e.target.value.trim().match(/^\d/)
		const isNameLong = e.target.value.trim().length > 30;
		const validName = !nameIsBlank && !nameStartWithNumber && !nameInUse && !nameContainsSys && !nameIsReserved && !isNameLong;
		let nameError = "";
		if (nameIsBlank) {
			nameError = this.props.t("errors.name_required")
		} else if (nameStartWithNumber) {
			nameError = this.props.t("errors.name_starts_with_number")
		} else if (nameInUse) {
			nameError = this.props.t("errors.name_in_use")
		} else if (isNameLong) {
			nameError = this.props.t("errors.name_too_long")
		} else if (nameContainsSys) {
			nameError = this.props.t("errors.name_contains_sys")
		} else if (nameIsReserved) {
			nameError = this.props.t("errors.name_reserved")
		} else {
			nameError = ""
		}
		this.setState({
			attributeName: e.target.value,
			validName: validName,
			nameError,
		});
	};

	handleType = (e) => {
		let { DataTypes } = this;

		if (e.filter.value.trim() !== "") {
			DataTypes = DataTypes.filter((x) => x.text.toLowerCase().startsWith(e.filter.value.toLowerCase()));
		}
		this.setState({
			DataTypes: DataTypes,
		});
	};

	setAttributeType = (e) => {
		if (e.target.value === null) {
			this.setState({ attributeType: this.DataTypes[0] });
		} else {
			this.setState({ attributeType: e.target.value });
		}
		if (e.target.value !== "Picklist String") {
			this.setState({
				picklistError: {
					isValid: true,
					message: "",
				},
				picklist: "",
			});
		}
		if (e.target.value !== "State Field") {
			this.setState({
				statefieldError: {
					isValid: true,
					message: "",
				},
				statefield: [],
			});
		}
		if (e.target.value !== "Tree Dropdown") {
			this.setState({
				treedropdownError: {
					isValid: true,
					message: "",
				},
				treeDropdown: [{
					id: uuidv4(),
					text: "",
					parentId: null,
					items: [],
					root: true,
					expandedLevel: 1,
				}]
			});
		}
	};

	handleDateTimeType = (e) => {
		this.setState({ dateTimeType: e.value });
	};

	handleNumberType = (e) => {
		this.setState({
			numberType: e.value,
		});
	};

	handleDropdownChange = (e) => {
		let picklistError = this.CheckPicklistisProper(e.target.value);
		this.setState({
			picklist: e.target.value,
			picklistError: picklistError,
		});
	};

	handleStateFieldChange = (data) => {
		let statefieldError = this.CheckStateFieldisProper(data);
		this.setState({
			statefield: data,
			statefieldError: statefieldError,
		});
	};

	handleTreeDropdownChange = (data) => {
		const { treedropdownError } = this.state;
		const error = CheckErrorInTree(data);
		if (error !== "") {
			treedropdownError.isValid = false;
			treedropdownError.message = this.props.t("treedropdownerrors." + error, { ns: "attribute/tree_dropdown" });
		} else {
			treedropdownError.isValid = true;
			treedropdownError.message = "";
		}
		this.setState({
			treeDropdown: data,
			treedropdownError: treedropdownError,
		});
	};

	handleMirrorFieldChange = (e) => {
		this.setState({
			[e.target.name]: e.target.value,
		});
		switch (e.target.name) {
			case "entity":
				this.setState({
					relation: {},
					attribute: {},
				});
				break;
			case "relation":
				if (this.state.attribute === undefined || this.state.attribute === null || !this.state.attribute._id) {
					this.setState({
						attribute: {},
					});
				}
				break;
			default:
				break;
		}
	};

	CheckPicklistisProper = (data) => {
		const picklistValues = data
			.split("ɖ")
			.filter((option) => option.trim() !== "")
			.map((option) => option.trim());
		const picklistValuesMap = {};
		let picklistError = {
			isValid: true,
			message: "",
		};

		if (picklistValues.length === 0) {
			picklistError.isValid = false
			return picklistError;
		}

		for (const value of picklistValues) {
			picklistValuesMap[value] = picklistValuesMap[value] ? ++picklistValuesMap[value] : 1;
			if (picklistValuesMap[value] > 1) {
				picklistError.isValid = false;
				picklistError.message = this.props.t("errors.duplicate_picklist_values")
				break;
			}
		}
		return picklistError;
	};

	CheckStateFieldisProper = (data) => {
		const statefieldValues = data
			.filter((option) => option.name.trim() !== "")
			.map((option) => option.name.trim());

		const statefieldValuesMap = {};
		let statefieldError = {
			isValid: true,
			message: "",
		};

		if (statefieldValues.length === 0) {
			statefieldError.isValid = false
			return statefieldError;
		}
		for (const value of statefieldValues) {
			statefieldValuesMap[value] = statefieldValuesMap[value] ? ++statefieldValuesMap[value] : 1;
			if (statefieldValuesMap[value] > 1) {
				statefieldError.isValid = false;
				statefieldError.message = this.props.t("errors.duplicate_picklist_values");
				break;
			}
		}
		return statefieldError;
	};

	shouldCreateBeDisabled = () => {
		if (this.state.attributeName.trim() === "") {
			return true;
		}

		if (!this.state.validName) {
			return true;
		}

		if (this.state.attributeType.value === "Picklist String") {
			if (!this.state.picklistError.isValid) {
				return true;
			}

			if (this.state.picklist !== undefined && this.state.picklist.length === 0) {
				return true;
			}
		}

		if (this.state.attributeType.value === "State Field") {
			if (!this.state.statefieldError.isValid) {
				return true;
			}

			if (this.state.statefield !== undefined && this.state.statefield.length === 0) {
				return true;
			}
		}

		if (this.state.attributeType.value === "Tree Dropdown") {
			if (!this.state.treedropdownError.isValid) {
				return true;
			}

			if (this.state.treeDropdown.length === 0) {
				return true;
			}

			if (this.state.treeDropdown[0].text === "") {
				return true;
			}
		}

		if (this.state.attributeType.value === "Mirror") {
			if (!this.state.entity || !this.state.entity._id) {
				return true;
			}

			if (!this.state.relation || !this.state.relation._id) {
				return true;
			}

			if (!this.state.attribute || !this.state.attribute._id) {
				return true;
			}
		}

		return false;
	};

	createAttribute = async (e, keepFormVisible = false) => {
		this.setState({
			creatingAttribute: true,
		});
		e.preventDefault();
		let { createBtn, createAndNewBtn } = this;
		const { projectId } = this.props;

		createBtn.current.disabled = true;
		createAndNewBtn.current.disabled = true;

		let order = 10000000000;
		const sysName = this.generateSystemName(this.state.attributeName);

		if (this.props.allAttributes.length > 0) {
			let highestOrder = 10000000000;
			for (let attribute of this.props.allAttributes) {
				const order = parseInt(attribute.order);
				if (order > highestOrder) {
					highestOrder = order;
				}
			}
			order = highestOrder + 10000000000;
		}

		let data = this.Fields[this.state.attributeType.value];

		let properties = {};

		this.state.attributeName = this.state.attributeName.trim()

		for (let item of data) {
			properties[item.field] = this.state[item.state] || item.defaultValue;
		}

		if (
			properties.attributeType.value === "Mirror" &&
			(
				properties.attribute.attributeType === "Number" ||
				properties.attribute.attributeType === "DateTime" ||
				properties.attribute.attributeType === "Picklist String" ||
				properties.attribute.attributeType === "State Field"
			)
		) {
			let otherProperties = this.Fields[properties.attribute.attributeType];
			for (let item of otherProperties) {
				properties[item.field] = this.state[item.state] || item.defaultValue;
			}
		}

		// clear empty item from picklist - ali
		if (properties['picklist']) {
			let values = properties['picklist'].split('ɖ')
			values = values.filter(o => o.length > 0)
			for (let i = 0; i < values.length; i++) {
				values[i] = values[i].trim()
			}
			values = values.join('ɖ');
			properties['picklist'] = values
		}

		properties.attributeLabel = this.state.attributeName;
		properties.attributeType = this.state.attributeType.value;
		if (
			properties.attributeType === "String"
		) {
			properties.dummyLabel = DummyLabelHelper.getDummyLabel(properties.attributeLabel, properties.attributeType)
		} else if (properties.attributeType === "Image") {
			properties.allowedFileTypes = ["JPEG"];
		}
		properties.description = this.state.attributeName;
		properties.tooltip = this.state.attributeName;
		properties.required = false;
		properties.readOnly = false;
		properties.order = String(order);
		properties.sysName = sysName;
		if (properties.attributeType === "DateTime" && properties.dateTimeType === "time") {
			properties.setDefaultDate = true
			properties.defaultTime = ""
		}
		if (properties.attributeType === "State Field") {
			properties['required'] = true
		} else if (properties.attributeType === "Mirror") {
			// this is stored so  find the mirror attributetype 
			properties.mirroredAttributeType = properties.attribute.attributeType;
			properties.references = {
				entityId: properties.entity._id,
				linkedEntityId: properties.relation._id,
				attributeId: properties.attribute._id
			}
			delete properties['attribute'];
			delete properties['entity'];
			delete properties['relation'];
			delete properties['relationId'];
		}
		console.time("Create attribute");
		if (properties.attributeType === "Tree Dropdown") {
			const trimmedTreeDropdown = removeExtraSpaceFromTreeElement(properties['treeDropdown'])
			properties['treeDropdown'] = JSON.stringify(trimmedTreeDropdown)
		}
		if (properties.cellFormatting) {
			properties.cellFormatting.ifStatement = []
			properties.cellFormatting.elseStatement = []
			properties.cellFormatting = JSON.stringify(properties.cellFormatting)
		}
		if (properties.attributeType === "State Field") {
			let values = this.state.statefield
			values = values.filter(o => o.name.trim().length > 0)
			for (let i = 0; i < values.length; i++) {
				values[i]._id = uuidv4()
				values[i].name = values[i].name.trim()
				values[i].order = parseInt((i + 1) * 10000000000);
				values[i].languages = {};
			}
			properties['statefield'] = values
		}
		properties.languages = {}
		const attribute = await createAttribute(this.props.entityId, {
			subscriptionId: this.props.subscriptionId,
			projectId: projectId,
			properties: properties,
		});
		if (properties.attributeType === "Mirror") {
			attribute['entity'] = this.state.entity
			attribute['relation'] = this.state.relation
			attribute['attribute'] = this.state.attribute
		}
		console.timeEnd("Create attribute");
		if (attribute.status && attribute.status === "Failure") {
			this.props.closeDialog(true)
		} else {
			attribute.typeText = this.DataTypes.find((type) => type.value === this.state.attributeType.value).text;
			attribute.required = attribute.required === true;
			attribute.readOnly = attribute.readOnly === true;
			attribute.multiSelect = attribute.multiSelect === true;
			if (attribute.cellFormatting) {
				attribute.cellFormatting = JSON.parse(attribute.cellFormatting)
			}

			createBtn.current.disabled = false;
			createAndNewBtn.current.disabled = false;

			this.props.onCreate(attribute, keepFormVisible);

			this.setState({
				attributeName: "",
				attributeType: this.DataTypes[0],
				data: [...this.state.data, ...[attribute]],
				DataTypes: this.DataTypes,
				validName: true,
				nameError: "",
				picklistError: {
					isValid: true,
					message: "",
				},
				dateTimeType: "date",
				numberType: "integer",
				creatingAttribute: false,
				treeDropdown: [{
					id: uuidv4(),
					text: "",
					parentId: null,
					items: [],
					root: true,
					expandedLevel: 1
				}],
				treedropdownError: {
					isValid: true,
					message: ""
				}
			}, () => {
				const { attributeNameInput } = this;
				attributeNameInput.focus();
			});
		}
	};

	createAttributeandResetForm = (e) => {
		this.createAttribute(e, true);
		const { attributeNameInput } = this;
		attributeNameInput.focus();
	};

	generateSystemName = (attributeName) => {
		const initialSysName = attributeName.toLowerCase().trim().replace(/[^a-zA-Z]/g, "") || "attribute";
		const isSySNameInEnglish = this.isStringInEnglish(initialSysName);
		if (!isSySNameInEnglish) {
			return "attribute";
		} else {

			let sysName = initialSysName;
			let counter = 0;
			while (this.props.allAttributes.find((attribute) => attribute.sysName === sysName)) {
				counter++;
				sysName = initialSysName + counter;
			}
			return sysName;
		}
	}

	isStringInEnglish = (str) => {
		const isEnglish = /^[a-zA-Z0-9_]*$/.test(str);
		return isEnglish;
	}
}

const CreateAttributeDialogWithT = withTranslation([
	'attribute/create_dialog',
	"attribute/attribute_type",
	"attribute/tree_dropdown",
	"attribute/state_field",
])(CreateAttributeDialog);

CreateAttributeDialogWithT.defaultProps = {
	useSuspense: false
}

export default CreateAttributeDialogWithT